// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__KMSTv","type":"styles_type__10Ns_","choices":"styles_choices__3bctJ"};